import { MoneyType } from "../models/moneytype";
import * as participantRepo from "../repositories/participant";

export async function getMoneyTypes(planId: number): Promise<MoneyType[]> {
  return participantRepo.get(`/plans/${planId}/money-types/`);
}
